import { arrowLeftIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const ArrowLeft = createIcon({
  displayName: 'ArrowLeft',
  paths: [
    'M278.87 311.152l-181.035 181.034c-16.683 16.683-16.683 43.648 0 60.331l181.035 181.035c16.64 16.64 43.648 16.64 60.331 0 16.64-16.683 16.64-43.691 0-60.331l-108.198-108.198h664.985c23.595 0 42.667-19.115 42.667-42.667s-19.072-42.667-42.667-42.667h-664.994l108.207-108.206c16.64-16.64 16.64-43.648 0-60.331-16.683-16.64-43.691-16.64-60.331 0z'
  ],
  canvasPaths: canvasIconPaths(arrowLeftIcon)
})
